<template>
  <div class="flex items-center gap-x-1">
    <img :src="currentIcon" class="mt-[2px]" />
    <p :class="[textColor, extraClass]" class="text-sm font-medium">
      {{ text }}
    </p>
  </div>
</template>

<script>
import redEllipse from "../../../../assets/svg/red-ellipse.svg";
import greenEllipse from "../../../../assets/svg/green-ellipse.svg";
import grayEllipse from "../../../../assets/svg/grey-ellipse.svg";
import yellowEllipse from "../../../../assets/svg/yellow-ellipse.svg";
import blueEllipse from "../../../../assets/svg/blue-ellipse.svg";
import { lowerCase } from "@/core/helpers/utility";
export default {
  name: "ConnectionStatus",
  props: {
    status: {
      type: String,
      required: true,
      default: "",
    },
    text: {
      type: String,
      required: true,
      default: "",
    },
    extraClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      textColor: "text-gray-600",
      redEllipse,
      greenEllipse,
      grayEllipse,
      blueEllipse,
      yellowEllipse,
      currentIcon: "",
    };
  },
  mounted() {
    const status = lowerCase(this.status ?? this.text);
    if (status === "connected") {
      this.textColor = "text-estationsGreen-700";
      this.currentIcon = this.greenEllipse;
    } else if (status === "faulty") {
      this.textColor = "text-[#BC8B2C]";
      this.currentIcon = this.yellowEllipse;
    } else if (status === "offline") {
      this.textColor = "text-gray-500";
      this.currentIcon = this.grayEllipse;
    } else if (status === "online") {
      this.textColor = "text-blue-500";
      this.currentIcon = this.blueEllipse;
    }
  },

  watch: {
    text(newText) {
      const status = lowerCase(this.status ?? this.text);
      if (status === "connected") {
        this.textColor = "text-estationsGreen-700";
        this.currentIcon = this.greenEllipse;
      } else if (status === "faulty") {
        this.textColor = "text-[#BC8B2C]";
        this.currentIcon = this.yellowEllipse;
      } else if (status === "offline") {
        this.textColor = "text-gray-500";
        this.currentIcon = this.grayEllipse;
      } else if (status === "online") {
        this.textColor = "text-blue-500";
        this.currentIcon = this.blueEllipse;
      }
    },
  },
};
</script>

<style>
/* table columns styling options */
.positive {
  font-weight: 500;
  font-size: 14px;
  color: #155c22;
}

.negative {
  font-weight: 500;
  font-size: 14px;
  color: #e11900;
}
</style>
